import {
  AllowedCallTypes,
  makeApiStateSelectors
} from "seneca-common/utils/apiStates";

import { studentParentsCrudStateConfig } from "../../../consts";

const {
  [AllowedCallTypes.FETCH]: {
    hasStarted: studentParentsAreFetching,
    didSucceed: studentParentsFetchSucceeded,
    didError: studentParentsFetchErrored,
    hasFinished: studentParentsFetchFinished,
    notSucceededOrStarted: studentParentsNeedFetching
  },

  [AllowedCallTypes.UPDATE]: {
    hasStarted: studentParentIsUpdating,
    didSucceed: studentParentUpdateSucceeded,
    didError: studentParentUpdateErrored,
    hasFinished: studentParentUpdateFinished,
    getErrorMessage: studentParentUpdateErrorMessage
  }
}: any = makeApiStateSelectors(studentParentsCrudStateConfig);

export {
  studentParentsAreFetching,
  studentParentsFetchSucceeded,
  studentParentsFetchErrored,
  studentParentsFetchFinished,
  studentParentsNeedFetching,
  studentParentIsUpdating,
  studentParentUpdateSucceeded,
  studentParentUpdateErrored,
  studentParentUpdateFinished,
  studentParentUpdateErrorMessage
};
